export var OPTION_SALUTATION_MR = "mr";
export var OPTION_SALUTATION_MRS = "mrs";
